import { intersect, literal, partial, struct } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Request = intersect(
	struct({
		type: iotsUtils.withDefault(literal('definite'), 'definite'),
	})
)(
	partial({
		from: iotsUtils.PositiveInteger,
		size: iotsUtils.PositiveIntegerUpTo(constants.api.pagination.maxPageSize),
	})
);

export const PartialRequest = partial({
	type: iotsUtils.withDefault(literal('definite'), 'definite'),
	from: iotsUtils.PositiveInteger,
	size: iotsUtils.PositiveIntegerUpTo(constants.api.pagination.maxPageSize),
});
